



































import { Component, Prop, PropSync, Ref, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ServiceTypeSelectModal extends Vue {
  @PropSync('open') internalOpen?: boolean;
  @Prop() availableServiceTypes?: any[];
  @Prop() showApplyToAllCheckbox?: boolean;
  @Prop() selectedServiceType?: number;
  
  @Ref('form') form?: {
    resetValidation: () => void;
    validate: () => boolean;
  };

  @Watch('$route') 
  routeChanged() {
    this.internalOpen = false;
  }

  @Watch('open') 
  onOpenChanged() {
    this.form?.resetValidation();
    this.serviceTypeId = this.selectedServiceType ?? null;
  }

  serviceTypeId: number | null = null;
  updateOtherUnits = false;

  submit() {
    this.internalOpen = false;

    this.$emit("serviceTypeSelected", { serviceTypeId: this.serviceTypeId, updateOtherUnits: this.updateOtherUnits });
  }
}
